import { Tag } from "primereact/tag";
import { Constant } from "../../constants/constant";

export default function ViewActiveStatus(prop: any) {
  return (
    <>
      <Tag
        className={prop.value === Constant.ACTIVE_STATUS_VAL ? "badge-status-active" : "badge-status-inactive"}
        value={prop.value === Constant.ACTIVE_STATUS_VAL ? "Active" : "Inactive"}
        rounded></Tag>
    </>
  );
}
